// https://github.com/mroderick/PubSubJS
import pubsub from 'pubsub-js';

delete window.PubSub;
window.EventManager = pubsub;

export const EventManager = window.EventManager;
